module.exports = __webpack_public_path__ + "22d5253a-df89-458b-b414-0191063f0b7f.30764a5dc43181582cfd.eot";


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/src/assets/fonts/22d5253a-df89-458b-b414-0191063f0b7f.eot
// module id = ../../../../../src/assets/fonts/22d5253a-df89-458b-b414-0191063f0b7f.eot
// module chunks = 2